import React, { useState, useMemo } from "react";
import {
  FiCheckCircle, FiClock, FiSearch, FiX, FiBell, FiUser,
  FiBarChart2, FiShield, FiSend, FiList, FiArrowUp,
  FiVolume2, FiVolumeX,
} from "react-icons/fi";
import "./Notification.css";

// ══════════════════════════════════════════════════════════════════════════════
// Dummy Data
// ══════════════════════════════════════════════════════════════════════════════
const ALERTS = [
  // Critical
  { id:"ALT-001", title:"PM2.5 Critical Threshold Breach",    solution:"AQM",        severity:"Critical", status:"Active",       device:"AQM-Sensor-02",  site:"Building A – Zone 3",    parameter:"PM2.5",           value:258,      threshold:150,     unit:"µg/m³", triggeredAt:"09:14", duration:"2h 18m", assignedTo:null,          occurrences:3, escalated:true,  channels:["SMS","Email","WhatsApp"], condition:"PM2.5 > 150 µg/m³",           comments:[] },
  { id:"ALT-002", title:"DO Level Critical – Aeration Tank",  solution:"STP",        severity:"Critical", status:"Active",       device:"STP-DO-01",      site:"Plant A – Aeration Tank",parameter:"Dissolved Oxygen",value:0.8,      threshold:2.0,     unit:"mg/L",  triggeredAt:"10:02", duration:"1h 30m", assignedTo:"Rajesh K.",   occurrences:1, escalated:false, channels:["SMS"],                    condition:"DO < 2.0 mg/L",               comments:["Aeration blower being inspected"] },
  { id:"ALT-003", title:"Water Tank Level Critical Low",       solution:"Water",      severity:"Critical", status:"Acknowledged", device:"WTR-Level-03",   site:"Block C Reservoir",      parameter:"Tank Level",      value:8,        threshold:20,      unit:"%",     triggeredAt:"07:45", duration:"3h 47m", assignedTo:"Suresh M.",   occurrences:1, escalated:false, channels:["Email","SMS"],            condition:"Level < 20%",                 comments:[] },
  { id:"ALT-004", title:"Fleet Vehicle Speed Violation",       solution:"Fleet",      severity:"Critical", status:"Active",       device:"FLT-GPS-07",     site:"Highway NH-48",          parameter:"Speed",           value:112,      threshold:80,      unit:"km/h",  triggeredAt:"11:20", duration:"12m",    assignedTo:null,          occurrences:1, escalated:false, channels:["Push","SMS"],             condition:"Speed > 80 km/h",             comments:[] },
  { id:"ALT-005", title:"STP Outlet BOD Exceeds Limit",        solution:"STP",        severity:"Critical", status:"Active",       device:"STP-BOD-Out",    site:"Plant A – Outlet",       parameter:"BOD",             value:34,       threshold:30,      unit:"mg/L",  triggeredAt:"08:33", duration:"4h 09m", assignedTo:"Priya R.",    occurrences:2, escalated:true,  channels:["Email","WhatsApp"],       condition:"BOD > 30 mg/L",               comments:["CPCB compliance risk"] },
  { id:"ALT-006", title:"Irrigation Pump Failure",             solution:"Irrigation", severity:"Critical", status:"Active",       device:"IRR-Pump-02",    site:"Field Zone B",           parameter:"Pump Status",     value:"Fault",  threshold:"Running",unit:"",      triggeredAt:"06:15", duration:"6h 17m", assignedTo:null,          occurrences:1, escalated:true,  channels:["SMS","Email"],            condition:"Pump = Fault",                comments:[] },
  // Warning
  { id:"ALT-007", title:"CO2 Level Elevated",                  solution:"AQM",        severity:"Warning",  status:"Active",       device:"AQM-CO2-01",     site:"Conference Room 2B",     parameter:"CO2",             value:1100,     threshold:1000,    unit:"ppm",   triggeredAt:"11:05", duration:"27m",    assignedTo:null,          occurrences:2, escalated:false, channels:["Push"],                   condition:"CO2 > 1000 ppm",              comments:[] },
  { id:"ALT-008", title:"Water Flow Rate Anomaly",             solution:"Water",      severity:"Warning",  status:"Acknowledged", device:"WTR-Flow-01",    site:"Block A Main Line",      parameter:"Flow Rate",       value:4.8,      threshold:3.5,     unit:"m³/h",  triggeredAt:"09:30", duration:"2h 02m", assignedTo:"Amit T.",     occurrences:1, escalated:false, channels:["Email"],                  condition:"Flow > 3.5 m³/h",             comments:["Monitoring closely"] },
  { id:"ALT-009", title:"STP pH Out of Range",                 solution:"STP",        severity:"Warning",  status:"Active",       device:"STP-pH-Inlet",   site:"Plant A – Inlet",        parameter:"pH",              value:9.1,      threshold:8.5,     unit:"",      triggeredAt:"10:45", duration:"47m",    assignedTo:null,          occurrences:3, escalated:false, channels:["Push","Email"],           condition:"pH > 8.5",                    comments:[] },
  { id:"ALT-010", title:"Soil Moisture Below Setpoint",        solution:"Irrigation", severity:"Warning",  status:"Active",       device:"IRR-Soil-04",    site:"Field Zone D",           parameter:"Soil Moisture",   value:28,       threshold:35,      unit:"%",     triggeredAt:"08:00", duration:"3h 32m", assignedTo:null,          occurrences:1, escalated:false, channels:["Push"],                   condition:"Moisture < 35%",              comments:[] },
  { id:"ALT-011", title:"Vehicle Idle Time Excessive",         solution:"Fleet",      severity:"Warning",  status:"Resolved",     device:"FLT-GPS-03",     site:"Depot A",                parameter:"Idle Time",       value:45,       threshold:30,      unit:"min",   triggeredAt:"07:00", duration:"1h 20m", assignedTo:"Driver Ramesh",occurrences:1, escalated:false, channels:["Push"],                   condition:"Idle > 30 min",               comments:[] },
  { id:"ALT-012", title:"AQM Sensor Battery Low",              solution:"AQM",        severity:"Warning",  status:"Active",       device:"AQM-Sensor-05",  site:"Parking Level B",        parameter:"Battery",         value:18,       threshold:20,      unit:"%",     triggeredAt:"06:40", duration:"4h 52m", assignedTo:null,          occurrences:1, escalated:false, channels:["Push"],                   condition:"Battery < 20%",               comments:[] },
  // Info
  { id:"ALT-013", title:"Firmware Update Available",           solution:"STP",        severity:"Info",     status:"Active",       device:"STP-GW-01",      site:"Plant A",                parameter:"Firmware",        value:"v2.4.1", threshold:"v2.5.0", unit:"",      triggeredAt:"05:00", duration:"6h 32m", assignedTo:null,          occurrences:1, escalated:false, channels:["Email"],                  condition:"New firmware v2.5.0 available",comments:[] },
  { id:"ALT-014", title:"Scheduled Maintenance Due",           solution:"Irrigation", severity:"Info",     status:"Active",       device:"IRR-Pump-01",    site:"Field Zone A",           parameter:"Runtime",         value:4980,     threshold:5000,    unit:"hrs",   triggeredAt:"00:00", duration:"11h 32m",assignedTo:null,          occurrences:1, escalated:false, channels:["Email"],                  condition:"Runtime approaching 5000 hrs", comments:[] },
  { id:"ALT-015", title:"New Device Connected",                solution:"Water",      severity:"Info",     status:"Resolved",     device:"WTR-Level-07",   site:"Block D",                parameter:"Connectivity",    value:"Online", threshold:"—",     unit:"",      triggeredAt:"16:20", duration:"—",      assignedTo:null,          occurrences:1, escalated:false, channels:["Push"],                   condition:"First heartbeat received",     comments:[] },
  { id:"ALT-016", title:"Daily Summary Report Ready",          solution:"AQM",        severity:"Info",     status:"Resolved",     device:"System",         site:"All Sites",              parameter:"Report",          value:"Ready",  threshold:"—",     unit:"",      triggeredAt:"23:59", duration:"—",      assignedTo:null,          occurrences:1, escalated:false, channels:["Email"],                  condition:"Scheduled daily 23:59",        comments:[] },
  { id:"ALT-017", title:"Fleet Trip Completed",                solution:"Fleet",      severity:"Info",     status:"Resolved",     device:"FLT-GPS-05",     site:"Route A→B",              parameter:"Trip Status",     value:"Done",   threshold:"—",     unit:"",      triggeredAt:"08:45", duration:"—",      assignedTo:null,          occurrences:1, escalated:false, channels:["Push"],                   condition:"Geo-fence exit + ignition off",comments:[] },
];

const CHANNELS_LOG = [
  { id:"MSG-001", alertId:"ALT-001", alertTitle:"PM2.5 Critical",     channel:"SMS",      recipient:"+91-98765-43210",   status:"Delivered", ts:"09:14:35", retries:0 },
  { id:"MSG-002", alertId:"ALT-001", alertTitle:"PM2.5 Critical",     channel:"Email",    recipient:"admin@plant.com",    status:"Delivered", ts:"09:14:36", retries:0 },
  { id:"MSG-003", alertId:"ALT-001", alertTitle:"PM2.5 Critical",     channel:"WhatsApp", recipient:"+91-98765-43210",   status:"Delivered", ts:"09:14:38", retries:0 },
  { id:"MSG-004", alertId:"ALT-002", alertTitle:"DO Level Critical",   channel:"SMS",      recipient:"+91-87654-32109",   status:"Delivered", ts:"10:02:11", retries:0 },
  { id:"MSG-005", alertId:"ALT-003", alertTitle:"Tank Level Low",      channel:"Email",    recipient:"ops@facility.com",  status:"Delivered", ts:"07:45:22", retries:0 },
  { id:"MSG-006", alertId:"ALT-003", alertTitle:"Tank Level Low",      channel:"SMS",      recipient:"+91-76543-21098",   status:"Failed",    ts:"07:45:23", retries:3 },
  { id:"MSG-007", alertId:"ALT-004", alertTitle:"Speed Violation",     channel:"Push",     recipient:"Fleet Manager App",  status:"Delivered", ts:"11:20:05", retries:0 },
  { id:"MSG-008", alertId:"ALT-005", alertTitle:"BOD High",            channel:"WhatsApp", recipient:"+91-65432-10987",   status:"Delivered", ts:"08:33:14", retries:0 },
  { id:"MSG-009", alertId:"ALT-006", alertTitle:"Pump Failure",        channel:"SMS",      recipient:"+91-54321-09876",   status:"Delivered", ts:"06:15:02", retries:0 },
  { id:"MSG-010", alertId:"ALT-007", alertTitle:"CO2 Elevated",        channel:"Push",     recipient:"All Managers",       status:"Delivered", ts:"11:05:30", retries:0 },
  { id:"MSG-011", alertId:"ALT-008", alertTitle:"Flow Anomaly",        channel:"Email",    recipient:"water@ops.com",      status:"Delivered", ts:"09:30:15", retries:0 },
  { id:"MSG-012", alertId:"ALT-009", alertTitle:"pH Out of Range",     channel:"Push",     recipient:"STP Operators",      status:"Pending",   ts:"10:45:01", retries:1 },
  { id:"MSG-013", alertId:"ALT-010", alertTitle:"Soil Moisture Low",   channel:"Push",     recipient:"Irrigation Team",    status:"Delivered", ts:"08:00:10", retries:0 },
  { id:"MSG-014", alertId:"ALT-012", alertTitle:"Battery Low",         channel:"Push",     recipient:"AQM Operators",      status:"Delivered", ts:"06:40:22", retries:0 },
];

const RULES = [
  { id:"RULE-01", name:"Critical Unacknowledged Escalation", condition:"Critical alert not acknowledged within 10 minutes", action:"Escalate to Site Manager via SMS",         solution:"All",        severity:"Critical", delayMin:10, active:true  },
  { id:"RULE-02", name:"Unresolved Critical – SMS to Head",  condition:"Critical alert unresolved for 30 minutes",          action:"Send SMS + Call to Facility Head",          solution:"All",        severity:"Critical", delayMin:30, active:true  },
  { id:"RULE-03", name:"AQM PM2.5 Duplicate Suppression",   condition:"Same PM2.5 alert triggered within 5 minutes",      action:"Suppress duplicate, increment counter",    solution:"AQM",        severity:"Warning",  delayMin:5,  active:true  },
  { id:"RULE-04", name:"STP BOD Compliance Alert",          condition:"BOD > 30 mg/L at outlet for > 2 readings",        action:"Alert Compliance Officer + Audit Log",     solution:"STP",        severity:"Critical", delayMin:0,  active:true  },
  { id:"RULE-05", name:"Fleet Speed Enforcement",           condition:"Speed > 80 km/h for more than 2 minutes",         action:"SMS to Fleet Manager + App Alert",          solution:"Fleet",      severity:"Critical", delayMin:2,  active:false },
  { id:"RULE-06", name:"Irrigation Pump Failure Response",  condition:"Pump fault status detected",                      action:"Immediate SMS + WhatsApp to field team",    solution:"Irrigation", severity:"Critical", delayMin:0,  active:true  },
];

// ─── Meta helpers ─────────────────────────────────────────────────────────────
const SEV = {
  Critical: { color:"#ef4444", bg:"#fee2e2", border:"#fca5a5" },
  Warning:  { color:"#f59e0b", bg:"#fef3c7", border:"#fcd34d" },
  Info:     { color:"#3b82f6", bg:"#dbeafe", border:"#93c5fd" },
};
const STS = {
  Active:       { color:"#ef4444", bg:"#fee2e2" },
  Acknowledged: { color:"#f59e0b", bg:"#fef3c7" },
  Resolved:     { color:"#10b981", bg:"#d1fae5" },
};
const SOL = {
  AQM:        { color:"#10b981", bg:"#d1fae5" },
  STP:        { color:"#8b5cf6", bg:"#ede9fe" },
  Water:      { color:"#3b82f6", bg:"#dbeafe" },
  Irrigation: { color:"#f59e0b", bg:"#fef3c7" },
  Fleet:      { color:"#f97316", bg:"#ffedd5" },
  Facility:   { color:"#667eea", bg:"#e0e7ff" },
};
const CH_STS = {
  Delivered: { color:"#10b981", bg:"#d1fae5" },
  Failed:    { color:"#ef4444", bg:"#fee2e2" },
  Pending:   { color:"#f59e0b", bg:"#fef3c7" },
};

// ─── Mini Trend Chart ─────────────────────────────────────────────────────────
const MiniTrendChart = ({ alert }) => {
  const numVal = typeof alert.value     === "number" ? alert.value     : 60;
  const numThr = typeof alert.threshold === "number" ? alert.threshold : null;
  const seed   = (alert.id.charCodeAt(4) || 5) * 100 + (alert.id.charCodeAt(5) || 1);
  const base   = numThr ? Math.min(numVal, numThr) * 0.55 : numVal * 0.55;
  const vals   = Array.from({ length: 12 }, (_, i) => {
    const noise = ((Math.sin(seed * 9301 + i * 49297 + 233) * 10000) % 1 + 1) % 1;
    return base + (numVal - base) * (i / 11 * 0.45 + noise * 0.55);
  });
  const max  = Math.max(...vals, numThr || 0) * 1.2;
  const W = 280, H = 72, BW = (W / 12) * 0.68;
  return (
    <svg viewBox={`0 0 ${W} ${H + 16}`} width="100%" style={{ display:"block" }}>
      {[0.25, 0.5, 0.75].map(y => (
        <line key={y} x1={0} y1={H*(1-y)} x2={W} y2={H*(1-y)} stroke="#f1f5f9" strokeWidth={1} />
      ))}
      {numThr && (
        <>
          <line x1={0} y1={H*(1-numThr/max)} x2={W} y2={H*(1-numThr/max)} stroke="#ef4444" strokeWidth={1.5} strokeDasharray="4,3" />
          <text x={4} y={H*(1-numThr/max)-3} fontSize={8} fill="#ef4444">Threshold {numThr}{alert.unit}</text>
        </>
      )}
      {vals.map((v, i) => {
        const bx = (i / 12) * W + (W / 12) * 0.16;
        const bh = Math.max(2, (v / max) * H);
        return <rect key={i} x={bx} y={H-bh} width={BW} height={bh} rx={2} fill={numThr && v > numThr ? "#fca5a5" : "#bfdbfe"} />;
      })}
      {Array.from({ length: 12 }, (_, i) => (
        <text key={i} x={(i/12)*W + W/24} y={H+12} fontSize={7} fill="#9ca3af" textAnchor="middle">{`${(11-i)*5}m`}</text>
      ))}
    </svg>
  );
};

// ─── Alert Detail Panel ───────────────────────────────────────────────────────
const AlertDetailPanel = ({ alert, onClose }) => {
  const [comment, setComment] = useState("");
  const [actionDone, setActionDone] = useState(null);

  if (!alert) return (
    <div className="ntf-no-sel">
      <div style={{ fontSize:48 }}>🔔</div>
      <div style={{ fontSize:15, fontWeight:700, color:"#374151", marginTop:8 }}>Select an alert</div>
      <div style={{ fontSize:12, color:"#9ca3af", marginTop:4 }}>Click any alert to view details and take action</div>
    </div>
  );

  const sv = SEV[alert.severity] || SEV.Info;
  const st = STS[alert.status]   || STS.Active;
  const sl = SOL[alert.solution] || { color:"#6b7280", bg:"#f3f4f6" };
  const hasNumericData = typeof alert.value === "number" && typeof alert.threshold === "number";

  return (
    <div className="ntf-detail">
      {/* Header */}
      <div className="ntf-det-header" style={{ borderLeft:`4px solid ${sv.color}` }}>
        <div style={{ flex:1 }}>
          <div style={{ display:"flex", gap:6, flexWrap:"wrap", marginBottom:6 }}>
            <span className="ntf-badge" style={{ background:sv.bg, color:sv.color }}>{alert.severity}</span>
            <span className="ntf-badge" style={{ background:st.bg, color:st.color }}>{alert.status}</span>
            <span className="ntf-badge" style={{ background:sl.bg, color:sl.color }}>{alert.solution}</span>
            {alert.escalated && <span className="ntf-badge" style={{ background:"#fee2e2", color:"#ef4444" }}>⬆ Escalated</span>}
            {alert.occurrences > 1 && <span className="ntf-badge" style={{ background:"#f3f4f6", color:"#6b7280" }}>{alert.occurrences}× grouped</span>}
          </div>
          <div style={{ fontSize:14, fontWeight:700, color:"#1e293b" }}>{alert.title}</div>
          <div style={{ fontSize:11, color:"#9ca3af", marginTop:3 }}>{alert.id} · {alert.device} · {alert.site}</div>
        </div>
        <button className="ntf-close-btn" onClick={onClose}><FiX size={16} /></button>
      </div>

      {/* A: Alert Information */}
      <div className="ntf-det-section">
        <div className="ntf-det-section-title">Alert Information</div>
        <div className="ntf-info-grid">
          {[
            { l:"Parameter",     v:`${alert.parameter}` },
            { l:"Current Value", v:`${alert.value}${alert.unit ? " " + alert.unit : ""}` },
            { l:"Threshold",     v:`${alert.threshold}${alert.unit ? " " + alert.unit : ""}` },
            { l:"Condition",     v:alert.condition },
            { l:"Triggered At",  v:alert.triggeredAt },
            { l:"Duration",      v:alert.duration },
            { l:"Assigned To",   v:alert.assignedTo || "Unassigned" },
            { l:"Channels",      v:alert.channels.join(", ") },
          ].map(r => (
            <div key={r.l} className="ntf-info-row">
              <div className="ntf-info-lbl">{r.l}</div>
              <div className="ntf-info-val">{r.v}</div>
            </div>
          ))}
        </div>
      </div>

      {/* B: Contextual Trend */}
      {hasNumericData && (
        <div className="ntf-det-section">
          <div className="ntf-det-section-title">Contextual Data — Last 60 Minutes</div>
          <div className="ntf-trend-wrap">
            <MiniTrendChart alert={alert} />
          </div>
          <div style={{ fontSize:11, color:"#9ca3af", marginTop:4 }}>
            {alert.parameter} readings — bars exceeding dashed threshold line are highlighted red
          </div>
        </div>
      )}

      {/* C: AI Note */}
      <div style={{ margin:"0 0 12px", padding:"8px 12px", background:"#f0fdf4", borderRadius:10, fontSize:12, color:"#374151", border:"1px solid #bbf7d0" }}>
        🤖 AI: {alert.severity === "Critical"
          ? `Immediate action required. ${alert.parameter} is ${typeof alert.value === "number" ? Math.round(((alert.value - alert.threshold) / alert.threshold) * 100) + "% above" : "breaching"} threshold. Duration: ${alert.duration}.`
          : alert.severity === "Warning"
          ? `Monitor closely. ${alert.parameter} approaching critical levels. Check ${alert.device} connectivity.`
          : `Low priority. ${alert.condition}. No immediate action needed.`}
      </div>

      {/* D: Actions */}
      <div className="ntf-det-section">
        <div className="ntf-det-section-title">Actions</div>
        <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginTop:8 }}>
          {alert.status === "Active" && (
            <button className="ntf-action-btn ntf-action-amber" onClick={() => setActionDone("Acknowledged")}>
              <FiCheckCircle size={13} /> Acknowledge
            </button>
          )}
          {alert.status !== "Resolved" && (
            <button className="ntf-action-btn ntf-action-green" onClick={() => setActionDone("Resolved")}>
              <FiCheckCircle size={13} /> Mark Resolved
            </button>
          )}
          <button className="ntf-action-btn ntf-action-blue" onClick={() => setActionDone("Assigned to technician")}>
            <FiUser size={13} /> Assign
          </button>
          <button className="ntf-action-btn ntf-action-red" onClick={() => setActionDone("Escalated")}>
            <FiArrowUp size={13} /> Escalate
          </button>
        </div>
        {actionDone && (
          <div style={{ marginTop:8, padding:"6px 10px", background:"#d1fae5", borderRadius:8, fontSize:12, color:"#065f46" }}>
            ✓ {actionDone} — action recorded at {new Date().toLocaleTimeString()}
          </div>
        )}
        {/* Comment */}
        <div style={{ marginTop:12 }}>
          <div style={{ fontSize:12, fontWeight:600, color:"#374151", marginBottom:6 }}>Add Comment</div>
          <div style={{ display:"flex", gap:6 }}>
            <input
              style={{ flex:1, border:"1px solid #e5e7eb", borderRadius:8, padding:"6px 10px", fontSize:12, outline:"none" }}
              placeholder="Type comment and press send…"
              value={comment}
              onChange={e => setComment(e.target.value)}
            />
            <button className="ntf-action-btn ntf-action-blue" style={{ padding:"6px 12px" }} onClick={() => setComment("")}>
              <FiSend size={13} />
            </button>
          </div>
          {alert.comments.map((c, i) => (
            <div key={i} style={{ padding:"6px 10px", background:"#f8fafc", borderRadius:8, fontSize:12, color:"#374151", marginTop:6, border:"1px solid #e5e7eb" }}>
              💬 {c}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// ─── Live Feed Tab ─────────────────────────────────────────────────────────────
const SOLUTIONS_ALL = ["All","AQM","STP","Water","Irrigation","Fleet","Facility"];
const SEVERITIES    = ["All","Critical","Warning","Info"];
const STATUSES      = ["All","Active","Acknowledged","Resolved"];

const LiveFeedTab = () => {
  const [selected, setSelected]   = useState(null);
  const [search, setSearch]       = useState("");
  const [sevFilter, setSevFilter] = useState("All");
  const [solFilter, setSolFilter] = useState("All");
  const [stsFilter, setStsFilter] = useState("All");

  const filtered = useMemo(() => ALERTS.filter(a => {
    if (sevFilter !== "All" && a.severity !== sevFilter) return false;
    if (solFilter !== "All" && a.solution !== solFilter) return false;
    if (stsFilter !== "All" && a.status   !== stsFilter) return false;
    if (search) {
      const q = search.toLowerCase();
      return a.title.toLowerCase().includes(q) || a.device.toLowerCase().includes(q) || a.id.toLowerCase().includes(q);
    }
    return true;
  }), [search, sevFilter, solFilter, stsFilter]);

  return (
    <div className="ntf-feed-layout">
      {/* Filter Bar */}
      <div className="ntf-filter-bar">
        <div className="ntf-search-wrap">
          <FiSearch size={14} color="#9ca3af" />
          <input className="ntf-search" placeholder="Search alerts by title, device, ID…" value={search} onChange={e => setSearch(e.target.value)} />
          {search && <button style={{ background:"none", border:"none", cursor:"pointer" }} onClick={() => setSearch("")}><FiX size={13} color="#9ca3af" /></button>}
        </div>
        <select className="ntf-sel" value={sevFilter} onChange={e => setSevFilter(e.target.value)}>
          {SEVERITIES.map(s => <option key={s}>{s}</option>)}
        </select>
        <select className="ntf-sel" value={solFilter} onChange={e => setSolFilter(e.target.value)}>
          {SOLUTIONS_ALL.map(s => <option key={s}>{s}</option>)}
        </select>
        <select className="ntf-sel" value={stsFilter} onChange={e => setStsFilter(e.target.value)}>
          {STATUSES.map(s => <option key={s}>{s}</option>)}
        </select>
        <span style={{ fontSize:12, color:"#9ca3af", marginLeft:"auto" }}>{filtered.length} alerts</span>
      </div>

      {/* Two-Panel Body */}
      <div className="ntf-feed-body">
        {/* Alert List */}
        <div className="ntf-alert-list">
          {filtered.map(a => {
            const sv = SEV[a.severity] || SEV.Info;
            const st = STS[a.status]   || STS.Active;
            const sl = SOL[a.solution] || { color:"#6b7280", bg:"#f3f4f6" };
            const isSel = selected?.id === a.id;
            return (
              <div
                key={a.id}
                className={`ntf-alert-row ${isSel ? "ntf-alert-row-sel" : ""}`}
                style={{ borderLeft:`4px solid ${sv.color}` }}
                onClick={() => setSelected(isSel ? null : a)}
              >
                <div style={{ flex:1, minWidth:0 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:6, marginBottom:4 }}>
                    <span style={{ fontWeight:700, fontSize:12, color:"#1e293b", flex:1, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.title}</span>
                    {a.escalated && <span style={{ fontSize:10, color:"#ef4444", fontWeight:800, flexShrink:0 }}>⬆</span>}
                  </div>
                  <div style={{ display:"flex", gap:5, flexWrap:"wrap", alignItems:"center" }}>
                    <span className="ntf-badge" style={{ background:sv.bg, color:sv.color, fontSize:10 }}>{a.severity}</span>
                    <span className="ntf-badge" style={{ background:sl.bg, color:sl.color, fontSize:10 }}>{a.solution}</span>
                    <span className="ntf-badge" style={{ background:st.bg, color:st.color, fontSize:10 }}>{a.status}</span>
                    {a.occurrences > 1 && <span className="ntf-badge" style={{ background:"#f3f4f6", color:"#6b7280", fontSize:10 }}>{a.occurrences}×</span>}
                  </div>
                  <div style={{ fontSize:11, color:"#9ca3af", marginTop:3, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{a.device} · {a.site}</div>
                </div>
                <div style={{ fontSize:11, color:"#9ca3af", textAlign:"right", flexShrink:0, marginLeft:8 }}>
                  <div style={{ display:"flex", alignItems:"center", gap:3, justifyContent:"flex-end" }}><FiClock size={10}/>{a.triggeredAt}</div>
                  <div style={{ marginTop:2 }}>{a.duration}</div>
                </div>
              </div>
            );
          })}
          {filtered.length === 0 && (
            <div style={{ padding:48, textAlign:"center", color:"#9ca3af", fontSize:13 }}>No alerts match current filters</div>
          )}
        </div>
        {/* Detail Panel */}
        <AlertDetailPanel alert={selected} onClose={() => setSelected(null)} />
      </div>
    </div>
  );
};

// ─── Timeline Tab ─────────────────────────────────────────────────────────────
const TimelineTab = () => {
  const sorted = [...ALERTS].sort((a, b) => b.triggeredAt.localeCompare(a.triggeredAt));
  return (
    <div className="ntf-timeline">
      <div className="ntf-panel-title" style={{ marginBottom:20 }}>Alert Timeline — Today (2026-02-28)</div>
      <div className="ntf-tl-track">
        {sorted.map((a, i) => {
          const sv = SEV[a.severity] || SEV.Info;
          const st = STS[a.status]   || STS.Active;
          const sl = SOL[a.solution] || { color:"#6b7280", bg:"#f3f4f6" };
          return (
            <div key={a.id} className="ntf-tl-item">
              <div className="ntf-tl-left">
                <div className="ntf-tl-dot" style={{ background:sv.color, boxShadow:`0 0 0 4px ${sv.bg}` }} />
                {i < sorted.length - 1 && <div className="ntf-tl-line" />}
              </div>
              <div className="ntf-tl-card">
                <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                  <span style={{ fontSize:12, fontWeight:700, color:"#6b7280", minWidth:44 }}>{a.triggeredAt}</span>
                  <span style={{ fontWeight:700, fontSize:13, color:"#1e293b", flex:1 }}>{a.title}</span>
                </div>
                <div style={{ display:"flex", gap:6, marginTop:5, flexWrap:"wrap" }}>
                  <span className="ntf-badge" style={{ background:sv.bg, color:sv.color, fontSize:10 }}>{a.severity}</span>
                  <span className="ntf-badge" style={{ background:sl.bg, color:sl.color, fontSize:10 }}>{a.solution}</span>
                  <span className="ntf-badge" style={{ background:st.bg, color:st.color, fontSize:10 }}>{a.status}</span>
                  <span className="ntf-badge" style={{ background:"#f3f4f6", color:"#6b7280", fontSize:10 }}>{a.device}</span>
                  {a.duration !== "—" && <span style={{ fontSize:11, color:"#9ca3af" }}>⏱ {a.duration}</span>}
                </div>
                {a.comments.length > 0 && (
                  <div style={{ fontSize:11, color:"#6b7280", marginTop:4 }}>💬 {a.comments[0]}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

// ─── Channels Tab ─────────────────────────────────────────────────────────────
const ChannelsTab = () => {
  const chIcon = { SMS:"📱", Email:"📧", WhatsApp:"💬", Push:"🔔" };
  const smsDel  = CHANNELS_LOG.filter(c => c.channel === "SMS"      && c.status === "Delivered").length;
  const emlDel  = CHANNELS_LOG.filter(c => c.channel === "Email"    && c.status === "Delivered").length;
  const waDel   = CHANNELS_LOG.filter(c => c.channel === "WhatsApp" && c.status === "Delivered").length;
  const pushDel = CHANNELS_LOG.filter(c => c.channel === "Push"     && c.status === "Delivered").length;
  const failed  = CHANNELS_LOG.filter(c => c.status === "Failed").length;
  const pending = CHANNELS_LOG.filter(c => c.status === "Pending").length;

  return (
    <div className="ntf-channels-panel">
      {/* Summary */}
      <div className="ntf-ch-summary">
        {[
          { label:"SMS Sent",      count:smsDel,  icon:"📱", color:"#10b981" },
          { label:"Email Sent",    count:emlDel,  icon:"📧", color:"#3b82f6" },
          { label:"WhatsApp Sent", count:waDel,   icon:"💬", color:"#25d366" },
          { label:"Push Sent",     count:pushDel, icon:"🔔", color:"#8b5cf6" },
          { label:"Failed",        count:failed,  icon:"❌", color:"#ef4444" },
          { label:"Pending",       count:pending, icon:"⏳", color:"#f59e0b" },
        ].map(c => (
          <div key={c.label} className="ntf-ch-chip" style={{ borderTop:`3px solid ${c.color}` }}>
            <span style={{ fontSize:20 }}>{c.icon}</span>
            <div style={{ fontSize:22, fontWeight:800, color:c.color }}>{c.count}</div>
            <div style={{ fontSize:11, color:"#6b7280" }}>{c.label}</div>
          </div>
        ))}
      </div>

      {/* Delivery Log Table */}
      <div className="ntf-panel-title" style={{ marginBottom:12 }}>Notification Delivery Log</div>
      <div className="ntf-table-wrap">
        <table className="ntf-table">
          <thead>
            <tr>
              <th>Msg ID</th>
              <th>Alert</th>
              <th>Channel</th>
              <th>Recipient</th>
              <th>Status</th>
              <th>Time</th>
              <th>Retries</th>
            </tr>
          </thead>
          <tbody>
            {CHANNELS_LOG.map(c => {
              const cs = CH_STS[c.status] || CH_STS.Pending;
              return (
                <tr key={c.id}>
                  <td style={{ fontFamily:"monospace", fontSize:11 }}>{c.id}</td>
                  <td style={{ fontSize:12 }}>{c.alertTitle}</td>
                  <td><span style={{ fontSize:14 }}>{chIcon[c.channel]}</span> {c.channel}</td>
                  <td style={{ fontSize:12, color:"#374151" }}>{c.recipient}</td>
                  <td><span className="ntf-badge" style={{ background:cs.bg, color:cs.color }}>{c.status}</span></td>
                  <td style={{ fontSize:12, color:"#6b7280" }}>{c.ts}</td>
                  <td style={{ textAlign:"center", color:c.retries > 0 ? "#ef4444" : "#9ca3af", fontSize:12, fontWeight:c.retries > 0 ? 700 : 400 }}>{c.retries}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

// ─── Rules Tab ────────────────────────────────────────────────────────────────
const RulesTab = () => {
  const [rules, setRules] = useState(RULES);
  const toggle = (id) => setRules(prev => prev.map(r => r.id === id ? { ...r, active: !r.active } : r));

  return (
    <div className="ntf-rules-panel">
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:16 }}>
        <div className="ntf-panel-title">Escalation & Rule Engine</div>
        <button className="ntf-action-btn ntf-action-blue"><FiShield size={13} /> Add Rule</button>
      </div>

      <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
        {rules.map(r => {
          const sv = SEV[r.severity] || SEV.Info;
          const sl = SOL[r.solution] || { color:"#6b7280", bg:"#f3f4f6" };
          return (
            <div key={r.id} className={`ntf-rule-card ${r.active ? "ntf-rule-active" : "ntf-rule-inactive"}`}>
              <div className="ntf-rule-header">
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:13, color:"#1e293b" }}>{r.name}</div>
                  <div style={{ fontSize:11, color:"#9ca3af", marginTop:1 }}>{r.id} · Delay: {r.delayMin} min</div>
                </div>
                <div style={{ display:"flex", gap:6, alignItems:"center" }}>
                  <span className="ntf-badge" style={{ background:sv.bg, color:sv.color }}>{r.severity}</span>
                  <span className="ntf-badge" style={{ background:sl.bg, color:sl.color }}>{r.solution}</span>
                  {/* Toggle switch */}
                  <div
                    onClick={() => toggle(r.id)}
                    style={{ width:42, height:22, borderRadius:11, background:r.active?"#10b981":"#d1d5db", cursor:"pointer", position:"relative", transition:"background .2s", flexShrink:0 }}
                  >
                    <div style={{ position:"absolute", top:2, left:r.active?"22px":"2px", width:18, height:18, borderRadius:"50%", background:"white", boxShadow:"0 1px 3px rgba(0,0,0,.25)", transition:"left .2s" }} />
                  </div>
                </div>
              </div>
              <div className="ntf-rule-body">
                <div className="ntf-rule-row"><span className="ntf-rule-lbl">Condition</span><span className="ntf-rule-val">{r.condition}</span></div>
                <div className="ntf-rule-row"><span className="ntf-rule-lbl">Action</span><span className="ntf-rule-val">{r.action}</span></div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Maintenance Mode Card */}
      <div className="ntf-maint-card">
        <FiVolumeX size={22} color="#6b7280" />
        <div style={{ flex:1 }}>
          <div style={{ fontWeight:700, fontSize:14, color:"#374151" }}>Maintenance Mode</div>
          <div style={{ fontSize:12, color:"#6b7280", marginTop:2 }}>Temporarily suppress all non-critical alerts during scheduled maintenance windows. Critical safety alerts are never suppressed.</div>
        </div>
        <button className="ntf-action-btn ntf-action-blue">Enable</button>
      </div>

      {/* Smart Features Info */}
      <div style={{ marginTop:16, display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(200px, 1fr))", gap:10 }}>
        {[
          { icon:"🔗", title:"Alert Grouping",    desc:"Repeated alerts grouped into one with occurrence count" },
          { icon:"🧠", title:"Alert Correlation",  desc:"Low Pressure + High Flow → Possible Pipeline Burst" },
          { icon:"🔕", title:"Suppression Rules",  desc:"Avoid notification spam for repeat events within X minutes" },
          { icon:"🛡️", title:"Role-Based Routing", desc:"Operators, Managers, Admins see appropriate alert scopes" },
        ].map(f => (
          <div key={f.title} style={{ padding:"12px 14px", background:"#f8fafc", borderRadius:10, border:"1px solid #e5e7eb" }}>
            <div style={{ fontSize:20, marginBottom:6 }}>{f.icon}</div>
            <div style={{ fontSize:12, fontWeight:700, color:"#374151" }}>{f.title}</div>
            <div style={{ fontSize:11, color:"#6b7280", marginTop:3 }}>{f.desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// ─── Analytics Tab ────────────────────────────────────────────────────────────
const AnalyticsTab = () => {
  const bySol    = useMemo(() => { const c = {}; ALERTS.forEach(a => { c[a.solution] = (c[a.solution]||0)+1; }); return Object.entries(c).sort((a,b)=>b[1]-a[1]); }, []);
  const bySev    = useMemo(() => { const c = {}; ALERTS.forEach(a => { c[a.severity] = (c[a.severity]||0)+1; }); return Object.entries(c).sort((a,b)=>b[1]-a[1]); }, []);
  const byDevice = useMemo(() => { const c = {}; ALERTS.forEach(a => { c[a.device] = (c[a.device]||0)+1; }); return Object.entries(c).sort((a,b)=>b[1]-a[1]).slice(0,6); }, []);
  const avgRes   = "1h 42m";
  const dayVols  = [5, 8, 12, 6, 14, 9, 17];
  const maxDay   = Math.max(...dayVols);
  const dayLbls  = ["Mon","Tue","Wed","Thu","Fri","Sat","Today"];

  const BarRow = ({ label, count, max, color, bg }) => (
    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:10 }}>
      <div style={{ width:110, fontSize:11, color:"#374151", fontWeight:500, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flexShrink:0 }}>{label}</div>
      <div style={{ flex:1, height:12, background:"#f3f4f6", borderRadius:6, overflow:"hidden" }}>
        <div style={{ width:`${(count/max)*100}%`, height:"100%", background:color, borderRadius:6, transition:"width .4s" }} />
      </div>
      <div style={{ fontSize:12, fontWeight:800, color, minWidth:20, textAlign:"right", flexShrink:0 }}>{count}</div>
    </div>
  );

  return (
    <div className="ntf-analytics">
      {/* Summary KPI strip */}
      <div className="ntf-an-strip">
        {[
          { label:"Total Alerts Today",        val: ALERTS.length,                    color:"#667eea" },
          { label:"Active Right Now",           val: ALERTS.filter(a=>a.status==="Active").length, color:"#ef4444" },
          { label:"Avg Resolution Time",        val: avgRes,                           color:"#10b981" },
          { label:"Escalated Alerts",           val: ALERTS.filter(a=>a.escalated).length, color:"#f59e0b" },
          { label:"Notifications Delivered",    val: CHANNELS_LOG.filter(c=>c.status==="Delivered").length, color:"#8b5cf6" },
          { label:"Delivery Failures",          val: CHANNELS_LOG.filter(c=>c.status==="Failed").length, color:"#ef4444" },
        ].map(k => (
          <div key={k.label} className="ntf-an-kpi" style={{ borderTop:`3px solid ${k.color}` }}>
            <div style={{ fontSize:22, fontWeight:800, color:k.color }}>{k.val}</div>
            <div style={{ fontSize:11, color:"#6b7280", marginTop:2 }}>{k.label}</div>
          </div>
        ))}
      </div>

      <div className="ntf-analytics-grid">
        {/* Alerts by Solution */}
        <div className="ntf-an-card">
          <div className="ntf-an-title">Alerts by Solution</div>
          <div style={{ marginTop:14 }}>
            {bySol.map(([sol, cnt]) => { const s = SOL[sol]||{color:"#6b7280",bg:"#f3f4f6"}; return <BarRow key={sol} label={sol} count={cnt} max={bySol[0][1]} color={s.color} bg={s.bg} />; })}
          </div>
        </div>

        {/* Alerts by Severity */}
        <div className="ntf-an-card">
          <div className="ntf-an-title">Alerts by Severity</div>
          <div style={{ marginTop:14 }}>
            {bySev.map(([sev, cnt]) => { const s = SEV[sev]||{color:"#6b7280",bg:"#f3f4f6"}; return <BarRow key={sev} label={sev} count={cnt} max={bySev[0][1]} color={s.color} bg={s.bg} />; })}
          </div>
        </div>

        {/* Most Frequent Devices */}
        <div className="ntf-an-card">
          <div className="ntf-an-title">Most Frequent Devices</div>
          <div style={{ marginTop:14 }}>
            {byDevice.map(([dev, cnt]) => <BarRow key={dev} label={dev} count={cnt} max={byDevice[0][1]} color="#667eea" bg="#e0e7ff" />)}
          </div>
        </div>

        {/* 7-Day Volume */}
        <div className="ntf-an-card">
          <div className="ntf-an-title">Alert Volume — Last 7 Days</div>
          <div style={{ display:"flex", alignItems:"flex-end", gap:6, height:100, marginTop:14 }}>
            {dayVols.map((v, i) => (
              <div key={i} style={{ flex:1, display:"flex", flexDirection:"column", alignItems:"center", gap:3 }}>
                <div style={{ fontSize:11, fontWeight:700, color:"#374151" }}>{v}</div>
                <div style={{ width:"100%", height:`${(v/maxDay)*80}px`, background:i===6?"#ef4444":"#667eea", borderRadius:"4px 4px 0 0", transition:"height .4s" }} />
                <div style={{ fontSize:10, color:"#9ca3af" }}>{dayLbls[i]}</div>
              </div>
            ))}
          </div>
          <div style={{ fontSize:11, color:"#9ca3af", marginTop:4 }}>Red = today's count</div>
        </div>
      </div>

      {/* AI Insight */}
      <div className="ntf-an-insight">
        🤖 AI Insight: AQM leads in alert frequency (PM2.5 breaches peak 06:00–11:00). STP has 2 critical compliance alerts — escalation triggered. Fleet speed violation resolved in 12 minutes. Recommendation: Increase HVAC ventilation schedule during morning hours to reduce AQM alert frequency by an estimated 40%.
      </div>
    </div>
  );
};

// ══════════════════════════════════════════════════════════════════════════════
// Main Notification Component
// ══════════════════════════════════════════════════════════════════════════════
const TABS = [
  { id:"feed",      label:"Live Feed",  icon:FiBell      },
  { id:"timeline",  label:"Timeline",   icon:FiList      },
  { id:"channels",  label:"Channels",   icon:FiSend      },
  { id:"rules",     label:"Rules",      icon:FiShield    },
  { id:"analytics", label:"Analytics",  icon:FiBarChart2 },
];

const Notification = () => {
  const [activeTab,  setActiveTab]  = useState("feed");
  const [timeRange,  setTimeRange]  = useState("Today");
  const [maintMode,  setMaintMode]  = useState(false);

  const kpi = useMemo(() => ({
    critical: ALERTS.filter(a => a.severity==="Critical" && a.status==="Active").length,
    warning:  ALERTS.filter(a => a.severity==="Warning"  && a.status==="Active").length,
    info:     ALERTS.filter(a => a.severity==="Info"     && a.status==="Active").length,
    resolved: ALERTS.filter(a => a.status==="Resolved").length,
    unacked:  ALERTS.filter(a => a.status==="Active" && !a.assignedTo).length,
    sent:     CHANNELS_LOG.filter(c => c.status==="Delivered").length,
  }), []);

  return (
    <div className="notification-container">
      {/* Page Header */}
      <div className="ntf-page-header">
        <div>
          <div className="ntf-page-title">🔔 Notification Command Center</div>
          <div className="ntf-page-sub">Real-time alert management across all IoTMATE solutions — Water · STP · AQM · Irrigation · Fleet · Facility</div>
        </div>
        <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
          {["Today","7D","30D"].map(t => (
            <button key={t} onClick={() => setTimeRange(t)}
              style={{ padding:"5px 14px", borderRadius:8, border:"none", cursor:"pointer", fontSize:12, fontWeight:700,
                background:timeRange===t?"#667eea":"#f1f5f9", color:timeRange===t?"white":"#374151" }}>
              {t}
            </button>
          ))}
          <button onClick={() => setMaintMode(m => !m)}
            style={{ padding:"5px 14px", borderRadius:8, border:maintMode?"2px solid #f59e0b":"1px solid #e5e7eb",
              cursor:"pointer", fontSize:12, fontWeight:700, background:maintMode?"#fef3c7":"white",
              color:maintMode?"#92400e":"#374151", display:"flex", alignItems:"center", gap:5 }}>
            {maintMode ? <FiVolumeX size={13}/> : <FiVolume2 size={13}/>}
            {maintMode ? "Maint. ON" : "Maint. Mode"}
          </button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="ntf-kpi-row">
        {[
          { label:"Critical Active",     val:kpi.critical, color:"#ef4444", icon:"🔴" },
          { label:"Warning Active",      val:kpi.warning,  color:"#f59e0b", icon:"🟠" },
          { label:"Info Active",         val:kpi.info,     color:"#3b82f6", icon:"🔵" },
          { label:"Resolved Today",      val:kpi.resolved, color:"#10b981", icon:"✅" },
          { label:"Unacknowledged",      val:kpi.unacked,  color:"#f97316", icon:"⏳" },
          { label:"Notifications Sent",  val:kpi.sent,     color:"#8b5cf6", icon:"📨" },
        ].map(k => (
          <div key={k.label} className="ntf-kpi-card" style={{ borderTop:`3px solid ${k.color}` }}>
            <span style={{ fontSize:22 }}>{k.icon}</span>
            <div style={{ fontSize:28, fontWeight:800, color:k.color }}>{k.val}</div>
            <div style={{ fontSize:11, color:"#6b7280", fontWeight:600, textAlign:"center" }}>{k.label}</div>
          </div>
        ))}
      </div>

      {/* Tab Bar */}
      <div className="ntf-tab-bar">
        {TABS.map(tab => (
          <button key={tab.id} className={`ntf-tab ${activeTab===tab.id?"ntf-tab-active":""}`}
            onClick={() => setActiveTab(tab.id)}>
            <tab.icon size={14} />
            {tab.label}
            {tab.id==="feed" && kpi.critical > 0 && (
              <span style={{ background:"#ef4444", color:"white", borderRadius:"50%", minWidth:18, height:18, fontSize:10, fontWeight:700, display:"inline-flex", alignItems:"center", justifyContent:"center", padding:"0 4px" }}>
                {kpi.critical}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Tab Panel */}
      <div className="ntf-panel">
        {activeTab==="feed"      && <LiveFeedTab />}
        {activeTab==="timeline"  && <TimelineTab />}
        {activeTab==="channels"  && <ChannelsTab />}
        {activeTab==="rules"     && <RulesTab />}
        {activeTab==="analytics" && <AnalyticsTab />}
      </div>
    </div>
  );
};

export default Notification;
